import React from 'react';
import DownloadLink from '../helper/DowloadLink';

class MultipleDatasets extends React.Component {
    constructor(props){
        super(props)
    }

    render () {
        if (this.props.data.length > 0) {
            this.imgPath = this.props.rootDir + '/' + this.props.data[0]['name'] + this.props.data[0]['thumbnail']
            this.alt = this.imgPath;
        }
        else {
            this.alt = "thumbnail"
        }
        return (
            <div>
                <hr></hr>
                <div style={{"display":"flex"}}>
                    <span style={{"margin":"10px","borderBlockColor":"black"}}>
                        <img src={this.imgPath } alt={this.alt}/>
                    </span>
                    <span style={{"marginTop":"20px","marginLeft":"20px"}}>
                        <h4>{this.props.title}</h4>
                        <ul className="list-bullet">
                        {this.props.data.map((d,i) => {
                            return (<li>
                                <a href='' onClick={()=> this.props.history.push(
                                    '/DatasetPage?name=' + d['name']
                                )} > {d['name']}</a> 
                                <h7 key={i}>{": " + d["description"]}</h7>
                                </li>)
                        })}
                        </ul>
                    </span>
                </div>
            </div>
        ) 
    }
}

export default MultipleDatasets;